<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
    <div class="cart-box">
        <s-header :name="'购物车'" :noback="true"></s-header>
        <div class="cart-body">
            <van-checkbox-group @change="groupChange" v-model="result" ref="checkboxGroup">
                <div v-for="(item, index) in list" :key="index">
                    <van-swipe-cell :right-width="50" v-for="(row,index) in item.merchant.cart_items" :key="index">
                        <div class="good-item">
                            <van-checkbox :name="row.id"/>
                            <div class="good-img"><img :src="$filters.prefix(row.product_img)" alt=""></div>
                            <div class="good-desc">
                                <div class="good-title">
                                    <span style="font-size: 18px">{{ row.product_name }}</span>
                                    <span>x{{ row.number }}</span>
                                </div>
                                <span>{{ row.sku_name }}</span>
                                <div class="good-btn">
                                    <div class="price">¥{{ row.price }}</div>
                                    <van-stepper
                                            integer
                                            :min="1"
                                            :max="5"
                                            :model-value="row.number"
                                            :name="row.id"
                                            async-change
                                            @change="onChange"
                                    />
                                </div>
                            </div>
                        </div>
                        <template #right>
                            <van-button
                                    square
                                    icon="delete"
                                    type="danger"
                                    class="delete-button"
                                    @click="deleteGood(row.id,'single')"
                            />
                        </template>
                    </van-swipe-cell>
                </div>
            </van-checkbox-group>
        </div>
        <van-submit-bar
                v-if="list.length > 0"
                class="submit-all van-hairline--top"
                :price="total * 100"
                button-text="结算"
                @submit="onSubmit"
        >
            <van-checkbox @click="allCheck" v-model:checked="checkAll">全选</van-checkbox>
            <div style="color: red;font-size: 12px;margin-left: 5px" @click="deleteGood" v-if="result.length>0">删除</div>
            <div style="color: red;font-size: 12px;margin-left: 5px;margin-right: 5px" @click="clearCart"
                 v-if="result.length>0">清空
            </div>
        </van-submit-bar>
        <div class="empty" v-if="!list.length">
            <img class="empty-cart" src="https://s.yezgea02.com/1604028375097/empty-car.png" alt="空购物车">
            <div class="title">购物车空空如也</div>
            <van-button round color="#8C211B" type="primary" @click="goTo" block>前往选购</van-button>
        </div>
        <nav-bar></nav-bar>
    </div>
</template>

<script>
    import {reactive, onMounted, computed, toRefs, ref} from 'vue'
    import {useRouter} from 'vue-router'
    // import { useStore } from 'vuex'
    import {showLoadingToast, closeToast, showFailToast, showConfirmDialog} from 'vant'
    import navBar from '@/components/NavBar'
    import sHeader from '@/components/SimpleHeader'
    import {deleteCartItem, modifyCart} from '@/service/cart'
    import {getCart} from "../service/cart";
    import {cartItemClear} from "@/service/product";

    export default {
        components: {
            navBar,
            sHeader
        },
        setup() {
            const router = useRouter()
            const chooseList = ref([])
            // const store = useStore()
            const state = reactive({
                checked: false,
                list: [],
                all: false,
                result: [],
                checkAll: false,

            })

            onMounted(() => {
                init()
            })

            const init = async () => {
                showLoadingToast({message: '加载中...', forbidClick: true});
                const {data} = await getCart()
                state.list = data
                closeToast();
            }

            const total = computed(() => {
                return totalFun()
            })

            function totalFun() {
                let sum = 0
                let cart_items = []
                state.list.map(item => {
                    item.merchant.cart_items.map(itemA => {
                        cart_items.push(itemA)
                    })
                })
                let _list = cart_items.filter(item => state.result.includes(item.id))
                chooseList.value = _list
                _list.forEach(item => {
                    sum += item.number * item.price
                })
                return sum
            }

            const goBack = () => {
                router.go(-1)
            }

            const goTo = () => {
                router.push({path: '/home'})
            }

            const onChange = async (value, detail) => {
                if (value > 5) {
                    showFailToast('超出单个商品的最大购买数量')
                    return
                }
                if (value < 1) {
                    showFailToast('商品不得小于0')
                    return
                }
                let cart_items = []
                state.list.map(item => {
                    item.merchant.cart_items.map(itemA => {
                        cart_items.push(itemA)
                    })
                })
                if (cart_items.filter(item => item.id == detail.name)[0].number == value) return
                showLoadingToast({message: '修改中...', forbidClick: true});
                const params = {
                    cart_id: detail.name,
                    num: value
                }
                await modifyCart(params)
                state.list.map(item => {
                    item.merchant.cart_items.map(itemA => {
                        if (itemA.id == detail.name) {
                            itemA.number = value
                        }
                    })
                })
                closeToast();
            }

            const onSubmit = async () => {
                if (state.result.length == 0) {
                    showFailToast('请选择商品进行结算')
                    return
                }
                let merchantId = ref('')
                let idItem = ref([])
                chooseList.value.forEach(item => {
                    merchantId.value = item.merchant_id;
                    idItem.value.push(item.id)
                })
                const data = JSON.stringify({
                    "type": "cart",
                    "data": [{"merchantId": merchantId.value, "idItem": idItem.value}]
                })
                console.log(data);
                //const params = JSON.stringify(state.result)
                router.push({path: '/good/order', query: {data}})
            }

            const deleteGood = async (id, type) => {
                let cart_ids = []
                if (type) {
                    cart_ids.push(id)
                } else {
                    state.result.map(function (item) {
                        cart_ids.push(item);
                    })
                }
                console.log(state.result)
                await deleteCartItem({cart_ids: JSON.stringify(cart_ids)})
                // store.dispatch('updateCart')
                init()
            }

            const groupChange = (result) => {
                let listLength = 0;
                state.list.map(item => {
                    listLength = item.merchant.cart_items.length
                })
                if (result.length == listLength) {
                    console.log(result)
                    state.checkAll = true
                } else {
                    console.log(3)
                    state.checkAll = false
                }
                state.result = result
            }

            const allCheck = () => {
                if (!state.checkAll) {
                    let data = []
                    state.list.map(item => {
                        item.merchant.cart_items.map(itemA => {
                            data.push(itemA.id)
                        })
                    })
                    state.result = data
                } else {
                    state.result = []
                }
            }

// 清空购物车
            async function clearCart() {
                showConfirmDialog({
                    title: '',
                    message:
                        '清空购物车？',
                }).then(async () => {
                    const data = await cartItemClear()
                    if (data.code == 200) {
                        init()
                    }
                })
                    .catch(() => {
                        // on cancel
                    });
            }

            return {
                ...toRefs(state),
                total,
                goBack,
                goTo,
                onChange,
                onSubmit,
                chooseList,
                deleteGood,
                groupChange,
                allCheck,
                clearCart,
                totalFun,
            }
        }
    }
</script>

<style lang="less">
    @import '../common/style/mixin';

    .cart-box {
        .cart-header {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 10000;
            .fj();
            .wh(100%, 44px);
            line-height: 44px;
            padding: 0 10px;
            .boxSizing();
            color: #252525;
            background: #fff;
            border-bottom: 1px solid #dcdcdc;

            .cart-name {
                font-size: 14px;
            }
        }

        .cart-body {
            margin: 16px 0 100px 0;
            padding-left: 10px;

            .good-item {
                display: flex;

                .good-img {
                    img {
                        .wh(100px, 100px)
                    }
                }

                .good-desc {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    flex: 1;
                    padding: 20px;

                    .good-title {
                        display: flex;
                        justify-content: space-between;
                    }

                    .good-btn {
                        display: flex;
                        justify-content: space-between;

                        .price {
                            font-size: 16px;
                            color: red;
                            line-height: 28px;
                        }

                        .van-icon-delete {
                            font-size: 20px;
                            margin-top: 4px;
                        }
                    }
                }
            }

            .delete-button {
                width: 50px;
                height: 100%;
            }
        }

        .empty {
            width: 50%;
            margin: 0 auto;
            text-align: center;
            margin-top: 200px;

            .empty-cart {
                width: 150px;
                margin-bottom: 20px;
            }

            .van-icon-smile-o {
                font-size: 50px;
            }

            .title {
                font-size: 16px;
                margin-bottom: 20px;
            }
        }

        .submit-all {
            margin-bottom: 50px;

            .van-checkbox {
                margin-left: 10px
            }

            .van-submit-bar__text {
                margin-right: 10px
            }

            .van-submit-bar__button {
                background: @primary;
            }
        }

        .van-checkbox__icon--checked .van-icon {
            background-color: @primary;
            border-color: @primary;
        }
    }
</style>
